// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: rEfCz2iwr7rKqS5mwAwHSJ
// Component: mthBts1npaTEv
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: 3n34xrGGUZkcT/component
import { Iframe } from "@plasmicpkgs/plasmic-basic-components"; // plasmic-import: CMDBvOhaI4s/codeComponent
import ProductCard from "../../ProductCard"; // plasmic-import: XnnzAWz-1wmuax/component
import Ratings from "../../Ratings"; // plasmic-import: LN1oqcvcc_f0mJ/component
import FeatureItem from "../../FeatureItem"; // plasmic-import: fZj-J9nF5TsCnZ/component
import BlogPost from "../../BlogPost"; // plasmic-import: 8glfZ7xZvSyklt/component
import Footer from "../../Footer"; // plasmic-import: LxqqBSLRZqOTHn/component
import { useScreenVariants as useScreenVariantseBz5EHfWhcIiS } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: eBz5eHfWHCIiS/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_library_plasmic_color_type_css from "../library_plasmic_color_type/plasmic_library_plasmic_color_type.module.css"; // plasmic-import: seaQhLVS4bbjiGvJJrRwyL/projectcss
import projectcss from "./plasmic_dirt.module.css"; // plasmic-import: rEfCz2iwr7rKqS5mwAwHSJ/projectcss
import sty from "./PlasmicHome.module.css"; // plasmic-import: mthBts1npaTEv/css
import ButtonArrowIcon from "./icons/PlasmicIcon__ButtonArrow"; // plasmic-import: jA1X_qQL9RhW5A/icon
import _3373661861889135539184286308817346397104058NjpgLa5Ko2Ljj from "./images/_3373661861889135539184286308817346397104058Njpg.jpg"; // plasmic-import: La5ko2LJJ/picture
import _3434016249669176447444004496738799610672373NpngHebJbjbv from "./images/_3434016249669176447444004496738799610672373Npng.png"; // plasmic-import: HEB_jbjbv/picture
import galinaNMiziNqvJx5MUnsplashjpgV70GzeErt6S0Yu from "./images/galinaNMiziNqvJx5MUnsplashjpg.jpg"; // plasmic-import: V70GzeErt6s0Yu/picture
import igorSonFvPxCqgtwcUnsplashjpgN5SKfMjAGrb6MG from "./images/igorSonFvPxCqgtwcUnsplashjpg.jpg"; // plasmic-import: n5sKfMjAGrb6mG/picture
import scottWebbORwRlTgBrPoUnsplashjpgYXbPZp3Of2SeDb from "./images/scottWebbORwRlTgBrPoUnsplashjpg.jpg"; // plasmic-import: yXbPZp3of2SEDb/picture
import freddieMarriageUcfKyTanLuUnsplashjpgRgtEv7KMoLbIf from "./images/freddieMarriageUcfKyTanLuUnsplashjpg.jpg"; // plasmic-import: rgtEV7kMOLbIf-/picture
import f2MhOuu7AKu8Qiwc from "./images/f2.jpg"; // plasmic-import: MHOuu7aKU8qiwc/picture
import f39ESkX5MnA4OmJ from "./images/f3.jpg"; // plasmic-import: 9E-skX5mnA4OmJ/picture
import f4HvF0BwctgBsZff from "./images/f4.jpg"; // plasmic-import: HvF0bwctgBsZff/picture
import b1QWpAql63Mx1UAq from "./images/b1.jpg"; // plasmic-import: qWPAql63MX1UAq/picture
import b2BlWnekameYlx19 from "./images/b2.jpg"; // plasmic-import: blWnekameYLX19/picture
import b33Zj4DO5GeyBvDf from "./images/b3.jpg"; // plasmic-import: 3ZJ4dO5GeyBvDf/picture
import adidasEv7J7DqGrGjCXb from "./images/adidas.png"; // plasmic-import: ev7j7dqGRGjCXb/picture
import hmJrkDtbtLWaOn83 from "./images/hm.png"; // plasmic-import: JRKDtbtLWaOn83/picture
import kappaWTg02Mowuh2B9T from "./images/kappa.png"; // plasmic-import: wTG02mowuh2b9t/picture
import lacosteKaj68TYyQaajMw from "./images/lacoste.png"; // plasmic-import: kaj68TYyQaajMw/picture
import levisRvI7PgNQj5Wtp from "./images/levis.png"; // plasmic-import: rvI7pgN-qj5Wtp/picture
import elPasOjpegFEh7M8Wp from "./images/elPasOjpeg.jpg"; // plasmic-import: fEH7m8_Wp/picture
import dirtDallasSoldOutjpgMbf58VBjk from "./images/dirtDallasSoldOutjpg.jpg"; // plasmic-import: MBF58VBjk/picture
import miamIjpegLXq8UELl from "./images/miamIjpeg.jpg"; // plasmic-import: LXq8uE_Ll/picture
import _3409813476444036608288544896470929646130839NpngYirSwc1Mb from "./images/_3409813476444036608288544896470929646130839Npng.png"; // plasmic-import: yirSwc1Mb/picture
import juijpgF8Ladf4Rp from "./images/juijpg.jpg"; // plasmic-import: F8LADF4rp/picture
import _3381583781817212155326300914264902575157836NjpgOa31X91DY from "./images/_3381583781817212155326300914264902575157836Njpg.jpg"; // plasmic-import: oa31x91dY/picture
import image2UGzQjp9UF from "./images/image2.jpg"; // plasmic-import: uGzQjp9uF/picture
import image4TQesnfWx from "./images/image4.jpg"; // plasmic-import: TQesnf_wx/picture
import image3O3FgkOxch from "./images/image3.jpg"; // plasmic-import: O3fgkOXCH/picture
import image5MbHIk91A from "./images/image5.jpg"; // plasmic-import: MbH-IK91A/picture
import image6XTlPoXuI from "./images/image6.jpg"; // plasmic-import: XTlPoXuI_/picture
import image7TT61T7K1J from "./images/image7.jpg"; // plasmic-import: tT61t7K1J/picture
import image8467ZGkVt from "./images/image8.jpg"; // plasmic-import: 467zGk_Vt/picture
import _885A96E7999F7Ae014716Db0Aebe5E65111Jpg0Ujr2DdNu from "./images/_885A96E7999F7Ae014716Db0Aebe5E65111Jpg.jpg"; // plasmic-import: 0ujr2DdNu/picture
import _7297D67932A0041B55828D1B40454Dbf1JpgL2Jw0FrGf from "./images/_7297D67932A0041B55828D1B40454Dbf1Jpg.jpg"; // plasmic-import: l2jw0FrGF/picture
import peaseAssociateSjpgY9EpBcJuQ from "./images/peaseAssociateSjpg.jpg"; // plasmic-import: Y9EpBcJuQ/picture
import jLjpgJwapJuT6N from "./images/jLjpg.jpg"; // plasmic-import: JWAPJuT6N/picture
import daSnakePiTpngGuS7Bw7Jt from "./images/daSnakePiTpng.png"; // plasmic-import: GuS7Bw7jt/picture
import _3391240941799675948400525220417699292435149N1JpgPEy679FAm from "./images/_3391240941799675948400525220417699292435149N1Jpg.jpg"; // plasmic-import: PEy679fAm/picture
import _33709226522947918340267872600024615334590289NjpgUNqnoDvF from "./images/_33709226522947918340267872600024615334590289Njpg.jpg"; // plasmic-import: uNQNODv-F/picture
import _3307311999396548807350116722549742184086050N1JpgUnT1Wjxp from "./images/_3307311999396548807350116722549742184086050N1Jpg.jpg"; // plasmic-import: unT1Wjxp_/picture
import _3391283015515846370626608824099622462839494N1Jpg3MnScJo3N from "./images/_3391283015515846370626608824099622462839494N1Jpg.jpg"; // plasmic-import: 3mnScJO3N/picture
import _33735967512756423163730991744239742351435727N1Jpg005YFcHt0 from "./images/_33735967512756423163730991744239742351435727N1Jpg.jpg"; // plasmic-import: 005yFcHt0/picture
import _3389804081773980284517972708567668004898155N1Jpg0XfatosEv from "./images/_3389804081773980284517972708567668004898155N1Jpg.jpg"; // plasmic-import: 0xfatosEv/picture
import _3388583479576158919329663098772743650319462N1JpgVgyRtz7Rd from "./images/_3388583479576158919329663098772743650319462N1Jpg.jpg"; // plasmic-import: vgyRTZ7rd/picture
import _3390857286158765470589566118396733230710670N1JpgCwfD9HMCg from "./images/_3390857286158765470589566118396733230710670N1Jpg.jpg"; // plasmic-import: cwfD9hMCg/picture
import tsWjpgP4BGhGVj8 from "./images/tsWjpg.jpg"; // plasmic-import: P4bGhGVj8/picture
import theWoodPr1JpegHGgQpEc70 from "./images/theWoodPr1Jpeg.jpg"; // plasmic-import: hGgQPEc70/picture
import download2JpegO6GumWnq from "./images/download2Jpeg.jpg"; // plasmic-import: o6GUM-WNQ/picture

export const PlasmicHome__VariantProps = new Array();

export const PlasmicHome__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHome__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseBz5EHfWhcIiS()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_library_plasmic_color_type_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__dy8Qt)}>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__uWcHh)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__uIw3)}>
                <Header
                  className={classNames("__wab_instance", sty.header__xa8Hh)}
                />

                {(
                  hasVariant(globalVariants, "screen", "mobile") ? true : true
                ) ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__b3ZjD)}
                  />
                ) : null}
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__hcCiq)}
                >
                  <h1
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1__k3AqV
                    )}
                  >
                    {'"Dirt" The Movie'}
                  </h1>
                  <h1
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1__qbgd3
                    )}
                  >
                    {
                      "To rescue his kidnapped partner, a rogue detective must join forces with a felon, his wife, and two mistresses to bring down an organized crime syndicate."
                    }
                  </h1>
                </p.Stack>
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__e0M8T)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__vSm4J)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                loading={"lazy"}
                src={{
                  src: _3373661861889135539184286308817346397104058NjpgLa5Ko2Ljj,
                  fullWidth: 2400,
                  fullHeight: 1200,
                  aspectRatio: undefined
                }}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8E8Eo
                )}
              >
                {"Dirt - The Trailer"}
              </div>
              <Iframe
                className={classNames("__wab_instance", sty.iframe__hdxu6)}
                preview={true}
                src={"https://www.youtube.com/embed/eKno9tmVaZc"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mOajg
                )}
              >
                {"Dirt - The Event"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__r35Yh
                )}
              >
                {"Photos from Dirt's Premiere"}
              </div>
              <div className={classNames(projectcss.all, sty.columns__aluKj)}>
                <div className={classNames(projectcss.all, sty.column__xo2WM)}>
                  {true ? (
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__w2VsE
                      )}
                      href={
                        hasVariant(globalVariants, "screen", "mobile")
                          ? "https://photos.app.goo.gl/AZsbozERsdaoCs4t8"
                          : "https://photos.app.goo.gl/AZsbozERsdaoCs4t8"
                      }
                      target={"_blank"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__kaeYw
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "mobile")
                          ? "Photos From Dallas"
                          : "Photos From Dallas"}
                      </div>
                    </a>
                  ) : null}
                </div>
                <div className={classNames(projectcss.all, sty.column__bvhp4)}>
                  {true ? (
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__tnfQ
                      )}
                      href={
                        hasVariant(globalVariants, "screen", "mobile")
                          ? "https://photos.app.goo.gl/7oyKxzgi8zsoAR3G8"
                          : "https://photos.app.goo.gl/7oyKxzgi8zsoAR3G8"
                      }
                      target={"_blank"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__w50ZP
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "mobile")
                          ? "Photos From Fort Lauderdale"
                          : "Photos From Fort Lauderdale"}
                      </div>
                    </a>
                  ) : null}
                </div>
                <div className={classNames(projectcss.all, sty.column__bR8Q)}>
                  {true ? (
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__bW4OI
                      )}
                      href={
                        hasVariant(globalVariants, "screen", "mobile")
                          ? "https://photos.app.goo.gl/ppqJBAYUR9jJPLka7"
                          : "https://photos.app.goo.gl/ppqJBAYUR9jJPLka7"
                      }
                      target={"_blank"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__wzETu
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "mobile")
                          ? "Photos From El Paso"
                          : "Photos From El Paso"}
                      </div>
                    </a>
                  ) : null}
                </div>
              </div>
              <Iframe
                className={classNames("__wab_instance", sty.iframe__ba8VC)}
                preview={true}
                src={"https://www.youtube.com/embed/-Hss1pmMNZo"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___4JKdG
                )}
              >
                {"In The News"}
              </div>
              <Iframe
                className={classNames("__wab_instance", sty.iframe__c3OfC)}
                preview={true}
                src={"https://www.youtube.com/embed/0FAN_qWxqBI"}
              />

              <Iframe
                className={classNames("__wab_instance", sty.iframe__qochM)}
                preview={true}
                src={"https://www.youtube.com/embed/pitxC5q2tVM"}
              />

              <div className={classNames(projectcss.all, sty.columns__rfsJ)}>
                <div className={classNames(projectcss.all, sty.column__xpQfY)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__ytC7)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loading={"lazy"}
                    src={{
                      src: _3434016249669176447444004496738799610672373NpngHebJbjbv,
                      fullWidth: 1271,
                      fullHeight: 644,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__kZmPo)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__eASgt
                    )}
                  >
                    {
                      "Media Powerhouse Maverick Entertainment and production house Imani Films have released their newest venture, a crime drama with more twists than an LA freeway."
                    }
                  </div>
                  <a
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link___2KLss
                    )}
                    href={
                      "https://www.ktsm.com/business/press-releases/ein-presswire/629210141/imani-films-and-maverick-entertainment-partner-to-release-twisted-crime-drama-dirt/"
                    }
                    target={"_blank"}
                  >
                    {"Read More"}
                  </a>
                </div>
              </div>
            </div>
            {true ? (
              <div className={classNames(projectcss.all, sty.freeBox__kaYkg)}>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2___9Ufxu
                  )}
                >
                  {"Top Collections"}
                </h2>
              </div>
            ) : null}
            {true ? (
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__fcQ10)}
              >
                <div className={classNames(projectcss.all, sty.column__mPgEl)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__uj8F6
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__uHDtG)}
                        displayHeight={"100%"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: galinaNMiziNqvJx5MUnsplashjpgV70GzeErt6S0Yu,
                          fullWidth: 1920,
                          fullHeight: 1278,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    onSale={true}
                    price={"$65.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__i97Bn
                        )}
                        numReviews={"(45 Review)"}
                      />
                    }
                    title={"Product"}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__jxWq)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__eJszl
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__o6X4M)}
                        displayHeight={"100%"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: igorSonFvPxCqgtwcUnsplashjpgN5SKfMjAGrb6MG,
                          fullWidth: 640,
                          fullHeight: 481,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    onSale={true}
                    price={"$80.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__lDdPl
                        )}
                        numReviews={"(45 Review)"}
                      />
                    }
                    title={"Product"}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__qIpCu)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__rCzN5
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__uv7LR)}
                        displayHeight={"100%"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: scottWebbORwRlTgBrPoUnsplashjpgYXbPZp3Of2SeDb,
                          fullWidth: 1920,
                          fullHeight: 1280,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    price={"$40.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__lUsdl
                        )}
                        numReviews={"(45 Review)"}
                      />
                    }
                    title={"Product"}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__hhmhs)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard___585As
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__f4Zo)}
                        displayHeight={"100%"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: freddieMarriageUcfKyTanLuUnsplashjpgRgtEv7KMoLbIf,
                          fullWidth: 640,
                          fullHeight: 427,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    onSale={true}
                    price={"$100.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__pCdnC
                        )}
                        numReviews={"(45 Review)"}
                      />
                    }
                    title={"Product"}
                  />
                </div>
              </p.Stack>
            ) : null}
            {true ? (
              <FeatureItem
                data-plasmic-name={"featureItem"}
                data-plasmic-override={overrides.featureItem}
                className={classNames("__wab_instance", sty.featureItem)}
              />
            ) : null}
            {true ? (
              <div className={classNames(projectcss.all, sty.freeBox__rmTn)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0Tzy7
                  )}
                >
                  {"Featured Products"}
                </div>
              </div>
            ) : null}
            {true ? (
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__mzxg7)}
              >
                <div className={classNames(projectcss.all, sty.column__zvPpp)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__jmtE
                    )}
                    price={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__qetA
                        )}
                      >
                        {"$160.00"}
                      </div>
                    }
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__bqJsk
                        )}
                        numReviews={"(12 Review)"}
                        stars={"two"}
                      />
                    }
                    title={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__nAnLs
                        )}
                      >
                        {"Designed Sofa"}
                      </div>
                    }
                    withReviews={true}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__ruyYg)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__ihptN
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__lSzM)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: f2MhOuu7AKu8Qiwc,
                          fullWidth: 270,
                          fullHeight: 310,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    price={"$200.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__psrdk
                        )}
                        stars={"four"}
                      />
                    }
                    title={"Dining Table"}
                    withReviews={true}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__l0HZu)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__tFl0
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__lZxC1)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: f39ESkX5MnA4OmJ,
                          fullWidth: 270,
                          fullHeight: 310,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    price={"$100.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings___4Apm5
                        )}
                        numReviews={"(23 Review)"}
                        stars={"five"}
                      />
                    }
                    title={"Chair and Table"}
                    withReviews={true}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__yWght)}>
                  <ProductCard
                    className={classNames(
                      "__wab_instance",
                      sty.productCard__t68S
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__hpLLp)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: f4HvF0BwctgBsZff,
                          fullWidth: 270,
                          fullHeight: 310,
                          aspectRatio: undefined
                        }}
                      />
                    }
                    price={"$299.00"}
                    ratings={
                      <Ratings
                        className={classNames(
                          "__wab_instance",
                          sty.ratings__cAHp6
                        )}
                        numReviews={"(35 Review)"}
                      />
                    }
                    title={"Modern Arm Chair"}
                    withReviews={true}
                  />
                </div>
              </p.Stack>
            ) : null}
            {true ? (
              <div className={classNames(projectcss.all, sty.freeBox__crLpf)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___6Hrzm
                  )}
                >
                  {"Latest Blog"}
                </div>
              </div>
            ) : null}
            {true ? (
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__uhpg)}
              >
                <div className={classNames(projectcss.all, sty.column__hvqwh)}>
                  <BlogPost
                    className={classNames(
                      "__wab_instance",
                      sty.blogPost___0YgVw
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__rIlYv)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: b1QWpAql63Mx1UAq,
                          fullWidth: 370,
                          fullHeight: 250,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column___5NWsp)}>
                  <BlogPost
                    className={classNames(
                      "__wab_instance",
                      sty.blogPost__vj4Rt
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__s8Wss)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: b2BlWnekameYlx19,
                          fullWidth: 370,
                          fullHeight: 250,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__q7Iz6)}>
                  <BlogPost
                    className={classNames(
                      "__wab_instance",
                      sty.blogPost__unHe6
                    )}
                    image={
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__tmKd6)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"100%"}
                        src={{
                          src: b33Zj4DO5GeyBvDf,
                          fullWidth: 370,
                          fullHeight: 250,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />
                </div>
              </p.Stack>
            ) : null}
            {true ? (
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__xEf3)}
              >
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__miM8L)}
                  displayHeight={"60px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"90px"}
                  src={{
                    src: adidasEv7J7DqGrGjCXb,
                    fullWidth: 90,
                    fullHeight: 60,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__xwKbn)}
                  displayHeight={"60px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"91px"}
                  src={{
                    src: hmJrkDtbtLWaOn83,
                    fullWidth: 91,
                    fullHeight: 60,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img___04UjL)}
                  displayHeight={"60px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"98px"}
                  src={{
                    src: kappaWTg02Mowuh2B9T,
                    fullWidth: 98,
                    fullHeight: 60,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__nxTm5)}
                  displayHeight={"60px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"124px"}
                  src={{
                    src: lacosteKaj68TYyQaajMw,
                    fullWidth: 124,
                    fullHeight: 60,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__j8Yd2)}
                  displayHeight={"60px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"125px"}
                  src={{
                    src: levisRvI7PgNQj5Wtp,
                    fullWidth: 125,
                    fullHeight: 60,
                    aspectRatio: undefined
                  }}
                />
              </p.Stack>
            ) : null}
            {true ? (
              <Footer
                data-plasmic-name={"footer"}
                data-plasmic-override={overrides.footer}
                className={classNames("__wab_instance", sty.footer)}
              />
            ) : null}
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"bigPlants"}
            data-plasmic-override={overrides.bigPlants}
            hasGap={true}
            className={classNames(projectcss.all, sty.bigPlants)}
          >
            {true ? (
              <div className={classNames(projectcss.all, sty.freeBox__tgwZq)}>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__aXjAu
                  )}
                >
                  {"Upcoming Events and Screenings:"}
                </h2>
                <div className={classNames(projectcss.all, sty.freeBox__c5Mq7)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__roGB)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loading={"lazy"}
                    src={{
                      src: elPasOjpegFEh7M8Wp,
                      fullWidth: 2000,
                      fullHeight: 1125,
                      aspectRatio: undefined
                    }}
                  />

                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__h2XDx)}
                    >
                      {true ? (
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__gkm2A
                          )}
                          href={
                            hasVariant(globalVariants, "screen", "mobile")
                              ? "https://www.eventbrite.com/e/dirt-red-carpet-premiere-tickets-598048578397"
                              : "https://www.eventbrite.com/e/dirt-red-carpet-premiere-tickets-598048578397"
                          }
                          target={"_blank"}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___7DwYc
                            )}
                          >
                            {hasVariant(globalVariants, "screen", "mobile")
                              ? "GET TICKETS"
                              : "Get Tickets"}
                          </div>
                          {(
                            hasVariant(globalVariants, "screen", "mobile")
                              ? true
                              : true
                          ) ? (
                            <ButtonArrowIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__kvSx
                              )}
                              role={"img"}
                            />
                          ) : null}
                        </a>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className={classNames(projectcss.all, sty.freeBox__uz9M5)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__dAfmC)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: dirtDallasSoldOutjpgMbf58VBjk,
                        fullWidth: 2000,
                        fullHeight: 1125,
                        aspectRatio: undefined
                      }}
                    />

                    {true ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___7A4Uy
                        )}
                      >
                        {true ? (
                          <a
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              sty.link__bdQin
                            )}
                            href={
                              "https://www.eventbrite.com/e/dirt-red-carpet-premiere-event-tickets-609527090937"
                            }
                            target={"_blank"}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__nmjXk
                              )}
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "GET TICKETS"
                                : "Get Tickets"}
                            </div>
                            {(
                              hasVariant(globalVariants, "screen", "mobile")
                                ? true
                                : true
                            ) ? (
                              <ButtonArrowIcon
                                className={classNames(
                                  projectcss.all,
                                  sty.svg__q1HcF
                                )}
                                role={"img"}
                              />
                            ) : null}
                          </a>
                        ) : null}
                      </div>
                    ) : null}
                    <div
                      className={classNames(projectcss.all, sty.freeBox__oeVrq)}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__g2RtF)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: miamIjpegLXq8UELl,
                          fullWidth: 2000,
                          fullHeight: 1125,
                          aspectRatio: undefined
                        }}
                      />

                      {true ? (
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__nbd1W
                          )}
                        >
                          {true ? (
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__kRQdc
                              )}
                              href={
                                "https://www.eventbrite.com/e/dirt-red-carpet-premiere-tickets-609550460837"
                              }
                              target={"_blank"}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text___79RtL
                                )}
                              >
                                {hasVariant(globalVariants, "screen", "mobile")
                                  ? "GET TICKETS"
                                  : "Get Tickets"}
                              </div>
                              {(
                                hasVariant(globalVariants, "screen", "mobile")
                                  ? true
                                  : true
                              ) ? (
                                <ButtonArrowIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg___5H4C
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </a>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <div
              className={classNames(projectcss.all, sty.freeBox__bEeiZ)}
              id={"sponsor"}
            >
              <h1
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1__oztjJ
                )}
              >
                {"Become A Sponsor"}
              </h1>
              <h1
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1__f4CfM
                )}
              >
                {
                  "The sequel to \u201cDirt\u201d is called \u201cClutch\u201d.  If you would like to become a sponsor for \u201cClutch\u201d by showcasing your brand in the movie, please click this link to find out how:"
                }
              </h1>
              {true ? (
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    sty.link__tzhZ
                  )}
                  href={
                    hasVariant(globalVariants, "screen", "mobile")
                      ? "https://mailchi.mp/7245f43d3a20/clutch"
                      : "https://mailchi.mp/7245f43d3a20/clutch"
                  }
                  target={"_blank"}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cGwx
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobile")
                      ? "Sponsor Clutch"
                      : "Sponsor Clutch"}
                  </div>
                </a>
              ) : null}
              {true ? (
                <p
                  data-plasmic-name={"p"}
                  data-plasmic-override={overrides.p}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.p
                  )}
                >
                  {
                    'Choose from three impactful ways to support "Dirt" and make your mark on El Paso\'s film scene.'
                  }
                </p>
              ) : null}
              {true ? (
                <div className={classNames(projectcss.all, sty.freeBox__nDf9F)}>
                  {true ? (
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__c3Sqp)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={{
                        src: _3409813476444036608288544896470929646130839NpngYirSwc1Mb,
                        fullWidth: 741,
                        fullHeight: 307,
                        aspectRatio: undefined
                      }}
                    />
                  ) : null}
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pXu4C
                    )}
                  >
                    {"Billboard Sponsorship"}
                  </div>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p7Wzm
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <ul
                          className={classNames(
                            projectcss.all,
                            projectcss.ul,
                            sty.ul__ik9F
                          )}
                        >
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li__udRr
                            )}
                          >
                            {
                              " Showcase your business logo on a prominent 14' x 48' billboard in El Paso"
                            }
                          </li>
                        </ul>
                      }

                      <React.Fragment>{""}</React.Fragment>
                      {
                        <ul
                          className={classNames(
                            projectcss.all,
                            projectcss.ul,
                            sty.ul__fOpIn
                          )}
                        >
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li__ofKvY
                            )}
                          >
                            {
                              "Promote the film and your brand to a wide local audience"
                            }
                          </li>
                        </ul>
                      }

                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </div>
                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__e1R9U)}
                    >
                      {true ? (
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__tNb0Z
                          )}
                          href={
                            "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=DXGJU57MSMMZ4"
                          }
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__jjbNp
                            )}
                          >
                            {'Sponsor the "Dirt" Billboard - $1000'}
                          </div>
                          {(
                            hasVariant(globalVariants, "screen", "mobile")
                              ? true
                              : true
                          ) ? (
                            <ButtonArrowIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg___53Exh
                              )}
                              role={"img"}
                            />
                          ) : null}
                        </a>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xNalh
                    )}
                  >
                    {""}
                  </div>
                </div>
              ) : null}
              {true ? (
                <div
                  className={classNames(projectcss.all, sty.freeBox___3AeCt)}
                >
                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__tk3Go)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__fXuEk
                        )}
                      >
                        {"Step and Repeat Banner Sponsorship"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__fpGkc
                    )}
                  >
                    {
                      "Feature your logo on our Step and Repeat Banner at premiere events in El Paso, Dallas, and Miami\nGain viral exposure as attendees share photos and videos with your logo"
                    }
                  </div>
                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__tBuYk)}
                    >
                      {true ? (
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__bh75J
                          )}
                          href={""}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__aldZa
                            )}
                          >
                            {"SOLD OUT"}
                          </div>
                        </a>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
              {true ? (
                <div className={classNames(projectcss.all, sty.freeBox__kga7F)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img___3WhBc)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"243px"}
                    loading={"lazy"}
                    src={
                      "https://f.playcode.io/p-1376929/v-1/b32354fe-08ae-4823-b420-d61f4341bc42/336777793-1277156922874953-6513762841267237928-n-1-1.jpg"
                    }
                  />

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mkJcE
                    )}
                  >
                    {"Logo (or Name) in Credits"}
                  </div>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__y4INn
                    )}
                  >
                    {
                      "Add your logo or name to the film credits, visible to everyone who watches the film\nAssociate your brand with a local project that resonates with audiences worldwide"
                    }
                  </div>
                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__e8Xk2)}
                    >
                      {true ? (
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__ax5Av
                          )}
                          href={""}
                          target={"_blank"}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___7SNt8
                            )}
                          >
                            {hasVariant(globalVariants, "screen", "mobile")
                              ? "SOLD OUT"
                              : "SOLD OUT"}
                          </div>
                        </a>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
              <div className={classNames(projectcss.all, sty.freeBox__wRhkk)}>
                <div className={classNames(projectcss.all, sty.columns__q7Pfn)}>
                  <div className={classNames(projectcss.all, sty.column__ut4Y)}>
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img___4Fdu9)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: juijpgF8Ladf4Rp,
                        fullWidth: 118,
                        fullHeight: 153,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___6Ej13)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__fStdH
                      )}
                    >
                      {"Meet the Cast and Crew"}
                    </h2>
                  </div>
                  {(
                    hasVariant(globalVariants, "screen", "mobile") ? true : true
                  ) ? (
                    <div
                      className={classNames(projectcss.all, sty.column___079RC)}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img___95No7)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: juijpgF8Ladf4Rp,
                          fullWidth: 118,
                          fullHeight: 153,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  ) : null}
                </div>
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img___0MQnQ)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: _3381583781817212155326300914264902575157836NjpgOa31X91DY,
                    fullWidth: 1500,
                    fullHeight: 844,
                    aspectRatio: undefined
                  }}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___2E3Xn
                  )}
                >
                  {
                    '\u201cDirt\u201d prominently features El Paso actors, including actress Sophia Knolton, known for "Christmas with the Carters",  prominent Univision weatherman Aldo Acosta, "Valentine\'s Date" actress and El Paso native Kathy Thomas-Aldrich, and "El Sue\u00f1o" actress Diajesma Orozco.  Other El Paso actors with prominent roles are pro wrestler Frank Stone, Jorge Estrada, and Jesus Moralez.. The title role \u201cDirt\u201d is played by actor Tyrone Betters, known for is role in A True Christmas. It also stars actor Jamal Woolard, best known for portraying rapper The Notorious B.I.G. in the film "Notorious", and in the Tupac Shakur biopic "All Eyez on Me".'
                  }
                </div>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__kvbnf
                  )}
                >
                  {"Behind The Scenes"}
                </h2>
                <div className={classNames(projectcss.all, sty.columns__iyPrd)}>
                  <div className={classNames(projectcss.all, sty.column__hn2B)}>
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__bznKq)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image2UGzQjp9UF,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___4PsP9)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__j3Ty)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image4TQesnfWx,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___8IKp3)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__wjKfN)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image3O3FgkOxch,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__incea)}>
                  <div
                    className={classNames(projectcss.all, sty.column__wyHnz)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img___19Fbk)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image5MbHIk91A,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__pr8Mf)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__qZ2RM)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image6XTlPoXuI,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__taonz)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__gaF9P)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image7TT61T7K1J,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__rnCLe)}>
                  <div
                    className={classNames(projectcss.all, sty.column__bh2S4)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__oWBwu)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: image8467ZGkVt,
                        fullWidth: 297,
                        fullHeight: 297,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__xHzIc)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__eRak2)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        "https://f.playcode.io/p-1385389/v-1/1715e800-15f7-40fd-a7f5-02d0791cabb2/499ef947-f14a-fe73-d94c-312223343e61-1-3.jpg"
                      }
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__oMpDa)}>
                  <div
                    className={classNames(projectcss.all, sty.column__bIudu)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__qf8Zh)}
                      displayHeight={"281px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={
                        "https://f.playcode.io/p-1376929/v-1/70e34e3a-d3f6-4d58-ae6d-1581dbcc1e86/b080c6a5-dfb7-1118-3723-c567ea0d05e5-1.jpg"
                      }
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__bf2Kr)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__jEEpy)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        "https://f.playcode.io/p-1376929/v-1/7b6ba57c-3ecb-4cd0-8c90-9c6317d3b79a/885a96e7-999f-7ae0-1471-6db0aebe5e65-1-8.jpg"
                      }
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___9Oo0)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__imhMf)}
                      displayHeight={"281px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: _885A96E7999F7Ae014716Db0Aebe5E65111Jpg0Ujr2DdNu,
                        fullWidth: 446,
                        fullHeight: 270,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
                <div
                  className={classNames(projectcss.all, sty.columns___2BqLd)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column___9D6R)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__bDvch)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: _7297D67932A0041B55828D1B40454Dbf1JpgL2Jw0FrGf,
                        fullWidth: 908,
                        fullHeight: 406,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__kublA
                  )}
                >
                  {
                    "The cast and crew of \u201cDirt\u201d thanks you for joining our movement, bringing Texas talent to worldwide audiences!"
                  }
                </div>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2___1A0Jz
                  )}
                >
                  {"Special Thanks to our Sponsors"}
                </h2>
                <div className={classNames(projectcss.all, sty.columns__nkOh0)}>
                  <div
                    className={classNames(projectcss.all, sty.column__upuVv)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__yReVz
                      )}
                      href={"http://peaseassociateslaw.com/site/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__lwCds)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: peaseAssociateSjpgY9EpBcJuQ,
                          fullWidth: 960,
                          fullHeight: 960,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__qr1B3)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link___3HeC3
                      )}
                      href={"https://www.jleessauce.com/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__bRVj1)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: jLjpgJwapJuT6N,
                          fullWidth: 3000,
                          fullHeight: 2250,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__mqCkl)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__v202Y
                      )}
                      href={"https://www.instagram.com/da_snakepit/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__rc3D2)}
                        displayHeight={"275px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: daSnakePiTpngGuS7Bw7Jt,
                          fullWidth: 371,
                          fullHeight: 391,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__qvlkH)}>
                  <div
                    className={classNames(projectcss.all, sty.column__sq5Dm)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__uTw2J
                      )}
                      href={"https://www.maverickentertainment.cc/"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__b3H7)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3391240941799675948400525220417699292435149N1JpgPEy679FAm,
                          fullWidth: 900,
                          fullHeight: 900,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div className={classNames(projectcss.all, sty.column__ePjQ)}>
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__hSuC
                      )}
                      href={
                        "https://noticiasya.com/el-paso/?mibextid=Zxz2cZ&fbclid=IwAR0bYWipFGI4-x9PuQhXL3juOKvqjK5yusYL-65hDpJQ5O6BBDRbQh-4mgQ"
                      }
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__c0KYp)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _33709226522947918340267872600024615334590289NjpgUNqnoDvF,
                          fullWidth: 441,
                          fullHeight: 441,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__s9IcB)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__u0Z3
                      )}
                      href={"https://www.perchesfuneralhomes.com/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__lhM16)}
                        displayHeight={"275px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3307311999396548807350116722549742184086050N1JpgUnT1Wjxp,
                          fullWidth: 1432,
                          fullHeight: 1850,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__jw4W)}>
                  <div
                    className={classNames(projectcss.all, sty.column__n8Iyj)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link___5Rt9J
                      )}
                      href={"https://www.grindjj.com/#/"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__fgFtc)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3391283015515846370626608824099622462839494N1Jpg3MnScJo3N,
                          fullWidth: 1500,
                          fullHeight: 954,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__neK5Q)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__rld7D
                      )}
                      href={"https://www.facebook.com/macsdowntown915/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__n1V6X)}
                        displayHeight={"161px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _33735967512756423163730991744239742351435727N1Jpg005YFcHt0,
                          fullWidth: 1440,
                          fullHeight: 966,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__qyqox)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link___8Ax89
                      )}
                      href={"https://americaneaglepb.com/index.html"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__bUooL)}
                        displayHeight={"225px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3389804081773980284517972708567668004898155N1Jpg0XfatosEv,
                          fullWidth: 1275,
                          fullHeight: 1275,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__th4NA)}>
                  <div
                    className={classNames(projectcss.all, sty.column__loSut)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__fmg1H
                      )}
                      href={"https://redparrottx.com/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__cg9Sj)}
                        displayHeight={"272px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3388583479576158919329663098772743650319462N1JpgVgyRtz7Rd,
                          fullWidth: 489,
                          fullHeight: 608,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___3Bbdn)}
                  >
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__s7P0W
                      )}
                      href={"https://www.facebook.com/SkullKingProductionsLLC/"}
                      target={"_blank"}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img__ighI)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: _3390857286158765470589566118396733230710670N1JpgCwfD9HMCg,
                          fullWidth: 1080,
                          fullHeight: 506,
                          aspectRatio: undefined
                        }}
                      />
                    </a>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.columns__ap5S)}>
                  <a
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.column__uCYl
                    )}
                    href={"https://texasstylewrestling.com/videos"}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img___3EEij)}
                      displayHeight={"272px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: tsWjpgP4BGhGVj8,
                        fullWidth: 400,
                        fullHeight: 400,
                        aspectRatio: undefined
                      }}
                    />
                  </a>
                  <div
                    className={classNames(projectcss.all, sty.column__eC18X)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__z6Ch9)}
                      displayHeight={"272px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: theWoodPr1JpegHGgQpEc70,
                        fullWidth: 400,
                        fullHeight: 400,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__qSgy)}
                  />
                </div>
              </div>
              {true ? (
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__kw28E)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox___2Z6Bn)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__ofzym)}
                      displayHeight={
                        hasVariant(globalVariants, "screen", "mobile")
                          ? "374px"
                          : "618px"
                      }
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        "https://f.playcode.io/p-1376929/v-1/a1932ffe-b9d4-4631-a882-a9f4742a002b/26451e06-adf9-a37a-ab1d-ae37c6fd847c-1-1.jpg"
                      }
                    />
                  </p.Stack>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox___2Wr)}
                  >
                    {true ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__whLoe
                        )}
                      >
                        <h1
                          className={classNames(
                            projectcss.all,
                            projectcss.h1,
                            projectcss.__wab_text,
                            sty.h1___6Jhjr
                          )}
                        >
                          {'About "Dirt"'}
                        </h1>
                      </div>
                    ) : null}
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dgGpD
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "mobile") ? (
                        <React.Fragment>
                          <React.Fragment>
                            {
                              '"Dirt" is the ninth movie filmed all or in part in El Paso by director '
                            }
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__rf74Z
                              )}
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "Bryan G Thompson"
                                : "Bryan G Thompson"}
                            </a>
                          }

                          <React.Fragment>
                            {
                              ', founder of Imani Films. The gritty storyline revolves around five characters who form an unlikely alliance against a common enemy. \n\nTo rescue his kidnapped partner, a rogue police detective must rely on the syndicate\u2019s top lieutenant "Dirt" along with the man\u2019s wife and two girlfriends all of whom have their own reasons for risking their lives to destroy the crime syndicate. \n\nThe movie was filmed entirely in El Paso and features Univision weather anchor '
                            }
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__fdVao
                              )}
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "Aldo Acosta"
                                : "Aldo Acosta"}
                            </a>
                          }

                          <React.Fragment>
                            {", professional wrestler "}
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__ooPOv
                              )}
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "Frank Stone"
                                : "Frank Stone"}
                            </a>
                          }

                          <React.Fragment>
                            {", actress (UTEP graduate) "}
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__hLvj
                              )}
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "Diajesma Orozco"
                                : "Diajesma Orozco"}
                            </a>
                          }

                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#76B6FF" }}
                          >
                            {", "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#FAFCFF" }}
                          >
                            {"and actor "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__nmFuw
                              )}
                              href={
                                "https://en.wikipedia.org/wiki/Jamal_Woolard"
                              }
                            >
                              {hasVariant(globalVariants, "screen", "mobile")
                                ? "Jamal Woolard"
                                : "Jamal Woolard"}
                            </a>
                          }

                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#76B6FF" }}
                          >
                            {", "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#EBEDEF" }}
                          >
                            {"known for his "}
                          </span>
                          <React.Fragment>
                            {
                              "lead role in the film \u201cNotorious\u201d, just to name a few of the amazing cast members!  \n\nExecutive produced and distributed by Maverick Entertainment in association with Imani Films, the film is scheduled for release in late 2023 on multiple platforms including Peacock, Amazon, Tubi, Redbox and more!"
                            }
                          </React.Fragment>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <React.Fragment>
                            {
                              '"Dirt" is the ninth movie filmed all or in part in El Paso by director '
                            }
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__prCqs
                              )}
                              href={""}
                            >
                              {"Bryan G Thompson"}
                            </a>
                          }

                          <React.Fragment>
                            {
                              ', founder of Imani Films. The gritty storyline revolves around five characters who form an unlikely alliance against a common enemy. \n\nTo rescue his kidnapped partner, a rogue police detective must rely on the syndicate\u2019s top lieutenant "Dirt" along with the man\u2019s wife and two girlfriends all of whom have their own reasons for risking their lives to destroy the crime syndicate. \n\nThe movie was filmed entirely in El Paso and features Univision weather anchor '
                            }
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__rggT
                              )}
                              href={"https://www.facebook.com/AldoAcosta26"}
                            >
                              {"Aldo Acosta"}
                            </a>
                          }

                          <React.Fragment>
                            {", professional wrestler "}
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__kuHq
                              )}
                              href={
                                "https://prowrestling.fandom.com/wiki/JT_Flash"
                              }
                            >
                              {"Frank Stone"}
                            </a>
                          }

                          <React.Fragment>
                            {", actress (UTEP graduate) "}
                          </React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__yK9Qm
                              )}
                              href={"https://www.imdb.com/name/nm6118440/"}
                            >
                              {"Diajesma Orozco"}
                            </a>
                          }

                          <React.Fragment>{", and actor "}</React.Fragment>
                          {
                            <a
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link__j83RM
                              )}
                              href={
                                "https://en.wikipedia.org/wiki/Jamal_Woolard"
                              }
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#89C4FF" }}
                                >
                                  {"Jamal Woolard"}
                                </span>
                              </React.Fragment>
                            </a>
                          }

                          <React.Fragment>
                            {
                              ", known for his lead role in the film \u201cNotorious\u201d, just to name a few of the amazing cast members!  \n\nExecutive produced and distributed by Maverick Entertainment in association with Imani Films, the film is scheduled for release in late 2023 on multiple platforms including Peacock, Amazon, Tubi, Redbox and more!"
                            }
                          </React.Fragment>
                        </React.Fragment>
                      )}
                    </div>
                    {true ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__v6TIq
                        )}
                      >
                        {true ? (
                          <a
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              sty.link__di83B
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__xOyAo
                              )}
                            >
                              {"Watch The Trailer"}
                            </div>
                            <ButtonArrowIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__lXIm
                              )}
                              role={"img"}
                            />
                          </a>
                        ) : null}
                      </div>
                    ) : null}
                  </p.Stack>
                </p.Stack>
              ) : null}
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__gnTsF)}>
              <div className={classNames(projectcss.all, sty.columns__w69X9)}>
                <div
                  className={classNames(projectcss.all, sty.column__sUu7P)}
                />

                <div
                  className={classNames(projectcss.all, sty.column__yDqoi)}
                />

                <div className={classNames(projectcss.all, sty.column__umDb3)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__vhYmL)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"145px"}
                    loading={"lazy"}
                    src={{
                      src: download2JpegO6GumWnq,
                      fullWidth: 247,
                      fullHeight: 204,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__i4TQ
                    )}
                  >
                    {"All Rights Reserved 2023, Imani Films"}
                  </div>
                </div>
                <div
                  className={classNames(projectcss.all, sty.column__ds2Kc)}
                />

                <div className={classNames(projectcss.all, sty.column__bGPm)} />
              </div>
            </div>
          </p.Stack>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "featureItem", "footer", "bigPlants", "p"],
  featureItem: ["featureItem"],
  footer: ["footer"],
  bigPlants: ["bigPlants", "p"],
  p: ["p"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHome__ArgProps,
          internalVariantPropNames: PlasmicHome__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHome__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHome";
  } else {
    func.displayName = `PlasmicHome.${nodeName}`;
  }
  return func;
}

export const PlasmicHome = Object.assign(
  // Top-level PlasmicHome renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    featureItem: makeNodeComponent("featureItem"),
    footer: makeNodeComponent("footer"),
    bigPlants: makeNodeComponent("bigPlants"),
    p: makeNodeComponent("p"),
    // Metadata about props expected for PlasmicHome
    internalVariantProps: PlasmicHome__VariantProps,
    internalArgProps: PlasmicHome__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Dirt - The Movie",
      description:
        'Discover "Dirt," the movie, and ways to support Dirt, featuring a talented cast and directed by Bryan G Thompson. Get involved and stay tuned for its exciting release!',
      ogImageSrc:
        "https://site-assets.plasmic.app/14618749855a8716e8fd3fd3b59a854b.jpg",
      canonical: "https://dirt-the-movie.netlify.app/"
    }
  }
);

export default PlasmicHome;
/* prettier-ignore-end */
